export default __webpack_public_path__ + "static/media/vanitythumb.7d65b417.png";